// extracted by mini-css-extract-plugin
export default {"line":"I_txV","thumb":"qfkco"};